export default __webpack_public_path__ + "static/media/sign_in_2.a3092612.png";